<template>
    <BreadCrumb PageTitle="Liste historique" />
    <ListeHistorique />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeHistorique from "@/components/Historique/ListeHistorique.vue";


export default defineComponent({
    name: "ListeHistoriquePage",
    components: {
        BreadCrumb,
        ListeHistorique,
    },
});
</script>